import { render, staticRenderFns } from "./staerke.vue?vue&type=template&id=e9d077e8&"
import script from "./staerke.vue?vue&type=script&lang=js&"
export * from "./staerke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports